import { PositionDetail } from '../config/positions';
import { LANG_ENV } from '../config/env';

export function normalizePosition(position: PositionDetail) {
    return {
        ...position,
        active: isTrue(position.active),
        displayed: isTrue(position.displayed),
    } as const;
}

function isTrue(value: PositionDetail['active'] | PositionDetail['displayed']) {
    if (typeof value === 'boolean') {
        return value;
    }

    // LANG_ENV can be "de", but positions are not available on DE sites
    return !!value[LANG_ENV as keyof typeof value];
}
